import { RootState } from "../rootState";
import { geoCalcEnabledSelector, geoCalcStyleSelector } from "../common/selector/configurationSelector";
import { isCesium } from "../../MapStore2/web/client/selectors/maptype";
import { connect } from "react-redux";
import {
    centerMapOnGeoCalculationAction,
    geoCalcGeometryRemovedAction,
    loadGeoCalculationsAction,
    loadVisualisedGeoCalculationAction,
    requestGeoCalcGeometryAction,
    setGeoCalculationVisibilityAction,
} from "./redux";
import { GeoCalc, GeoCalcDispatchProps, GeoCalcStateProps } from "./GeoCalc";
import { GeoCalcStyle } from "./types";
import GeoCalculationItem from "./dto/GeoCalculationItem";
import { geoCalculationsByIdsActionCreator, GeoCalculationsByIdsServiceParams } from "../api/api-packages";
import { geoCalculationsActionCreator } from "../api/api-packages";

const mapStateToProps = (state: RootState): GeoCalcStateProps => {
    return {
        enabled: geoCalcEnabledSelector(state) && !isCesium(state),
        allCalculations:
            state.geoCalcList && state.geoCalcList.allCalculations ? state.geoCalcList.allCalculations : [],
        treeItems: (state.geoCalcList && state.geoCalcList.items) || [],
        geoCalcUrlIds: state.urlParams.geoCalcIds,
        axiosInitialized: state.axiosState?.initialized,
        ticket: state.session?.ticket,
        geoCalcStyle: geoCalcStyleSelector(state),
    };
};

const mapDispatchToProps = (dispatch: any): GeoCalcDispatchProps => {
    return {
        handleRequestGeoCalcList: () => dispatch(geoCalculationsActionCreator({})),
        handleLoadGeoCalcList: (geoCalcList: GeoCalculationItem[]) => dispatch(loadGeoCalculationsAction(geoCalcList)),
        handleGeoCalculationAdded: (calculationId: string) => dispatch(requestGeoCalcGeometryAction(calculationId)),
        handleGeoCalculationVisibilityToggled: (geoCalculationId: number, visibility: boolean) =>
            dispatch(setGeoCalculationVisibilityAction(geoCalculationId, visibility)),
        handleGeoCalculationRemoved: (geoCalculationId: number) =>
            dispatch(geoCalcGeometryRemovedAction(geoCalculationId)),
        handleGeoCalculationZoom: (calculationId?: string) => dispatch(centerMapOnGeoCalculationAction(calculationId)),
        handleLoadVisualisedGeoCalculation: (geoCalculations: GeoCalculationItem[], style: GeoCalcStyle) =>
            dispatch(loadVisualisedGeoCalculationAction(geoCalculations, style)),
        handleRequestGeoCalculationsByIds: (restOptions: GeoCalculationsByIdsServiceParams) =>
            dispatch(geoCalculationsByIdsActionCreator(restOptions)),
    };
};

export const ConnectedGeoCalc = connect(mapStateToProps, mapDispatchToProps)(GeoCalc);
